import { Channel, ChannelFilters, StreamChat } from 'stream-chat';
import { Client } from 'src/store/clients/types';
import { ChannelMembershipType } from 'src/store/messages/types';

export const baseChannelsFilter: ChannelFilters = {
  type: 'messaging',
  disabled: false,
};

export const getMessagesChannels = async (
  chatClient: StreamChat,
  filter: any,
) => {
  const channels = await chatClient.queryChannels(filter, {}, {});
  return channels;
};

export const getChannelsWithUser = async (
  userData: { memberId: string; companyId: string | null },
  getstreamClient: StreamChat,
) => {
  const companyFilter = userData.companyId
    ? { companyID: userData.companyId }
    : {};
  const channelFilter = {
    ...baseChannelsFilter,
    members: {
      $in: [userData.memberId],
    },
    ...companyFilter,
  };
  return getstreamClient.queryChannels(channelFilter as ChannelFilters, {}, {});
};

export const getCompanyChannel = async (
  companyID: string,
  getstreamClient: StreamChat,
) => {
  const channelFilter = {
    ...baseChannelsFilter,
    companyID: `${companyID}`,
  };
  const channels: Channel[] = await getstreamClient.queryChannels(
    channelFilter as ChannelFilters,
    {},
    {},
  );
  return channels;
};

export const findMessageChannelsWithSameComposition = async (
  chatClient: StreamChat,
  members: string[],
  companyID: string,
  activeClients: Client[],
  membershipType?: ChannelMembershipType,
) => {
  if (companyID) {
    const filter = {
      ...baseChannelsFilter,
      companyID: `${companyID}`,
      joined: true,
      ...(membershipType ? { membershipType } : {}),
    };
    const allChannels = await getMessagesChannels(chatClient, {
      ...filter,
    });
    return allChannels.filter((c) => c.data?.companyID === companyID) || [];
  }
  const activeClientIDs = (activeClients || []).map((c) => c.id);
  const predicate = members.map((memberId: string) => ({
    members: {
      $in: [memberId],
    },
  }));
  const filter = {
    ...baseChannelsFilter,
    $and: predicate,
  };

  const channels = (await getMessagesChannels(chatClient, filter)).filter(
    (c) =>
      // for non-company channels we compare client composition between form data and existing message channels
      !c.data?.companyID &&
      (Object.keys(c.state.members) || {})
        .filter((clientID) => {
          // filtering members to only include active clients
          const clientIDParts = clientID.split('_');
          // clientID get-stream ID in the form {portalID}_{clientID} split into parts to get clientID
          const cid = clientIDParts.pop();
          return activeClientIDs.includes(cid || '');
        })
        .every((m) => members.includes(m)),
  );
  return channels;
};
